import { Injectable } from '@angular/core'
import { ManageLoggedUser } from './manage-logged-user.service'

@Injectable({
    providedIn: 'root',
})
export class Session {
    static readonly KEY = 'partnerhub-id-user'

    constructor(private loggedUserService: ManageLoggedUser) {}

    get() {
        return this.loggedUserService.getLoggedAccountUser().loggedUser
    }

    getJwt() {
        return this.get()?.account_user_session_token
    }
}
